import { Button as Kobalte } from "@kobalte/core/button"
import { type ComponentProps, Show, splitProps } from "solid-js"
import { Icon, IconProps } from "./icon"

type ShadcnButtonVariant = "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
type LegacyButtonVariant = "primary"
type ShadcnButtonSize = "default" | "xs" | "sm" | "lg" | "icon" | "icon-xs" | "icon-sm" | "icon-lg"
type LegacyButtonSize = "small" | "normal" | "large"
type ButtonIconPlacement = "inline-start" | "inline-end"

export interface ButtonProps
  extends ComponentProps<typeof Kobalte>,
    Pick<ComponentProps<"button">, "class" | "classList" | "children"> {
  size?: ShadcnButtonSize | LegacyButtonSize
  variant?: ShadcnButtonVariant | LegacyButtonVariant
  icon?: IconProps["name"]
  iconPlacement?: ButtonIconPlacement
  asChild?: boolean
}

function variant(value?: ButtonProps["variant"]) {
  if (value === "primary") return "default"
  return value ?? "default"
}

function size(value?: ButtonProps["size"]) {
  if (value === "small") return "sm"
  if (value === "normal") return "default"
  if (value === "large") return "lg"
  return value ?? "default"
}

export function Button(props: ButtonProps) {
  const [split, rest] = splitProps(props, [
    "variant",
    "size",
    "icon",
    "iconPlacement",
    "asChild",
    "class",
    "classList",
    "children",
  ])
  const iconPlacement = () => split.iconPlacement ?? "inline-start"
  return (
    <Kobalte
      {...rest}
      data-component="button"
      data-size={size(split.size)}
      data-variant={variant(split.variant)}
      data-icon={split.icon ? iconPlacement() : undefined}
      classList={{
        ...split.classList,
        [split.class ?? ""]: !!split.class,
      }}
    >
      <Show when={split.icon && iconPlacement() === "inline-start"}>
        <Icon name={split.icon!} size="small" data-icon="inline-start" />
      </Show>
      {split.children}
      <Show when={split.icon && iconPlacement() === "inline-end"}>
        <Icon name={split.icon!} size="small" data-icon="inline-end" />
      </Show>
    </Kobalte>
  )
}
